/** @jsxImportSource @emotion/react */

import styled from "@emotion/styled";
import Dialog from "@mui/material/Dialog";
import { useAtomValue } from "jotai";
import { ModalStore } from "../../stores/modal";
import { ModalPaperCustom } from "./ModalPaperCustom";

const CustomStyleDialog = styled(Dialog)`
  z-index: 10000;
`;

export function Modal() {
  const modalStore = useAtomValue(ModalStore);
  const { children, onClose, isOpen } = modalStore;

  return (
    <CustomStyleDialog
      PaperComponent={ModalPaperCustom}
      open={isOpen}
      onClose={onClose}
      aria-labelledby="alert-modal-title"
      aria-describedby="alert-modal-description"
    >
      {children}
    </CustomStyleDialog>
  );
}
